// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__Y7kMH","title":"Layout_title__zGJI2"};